import { IContext } from "./IContext";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { LogGroup, CreateElement, SetStyles, Log, Scale } from ".././MyHelpers";
import { Settings } from "../Settings";
import { MyVideo } from "../MyVideo"
import { ITransitionFactory, ITransitionParams } from "../slot/Transition/ITransitionFactory";
import { ITransition } from "../slot/Transition/ITransition";
import { TransitionFactory } from "../slot/Transition/TransitionFactory";
import { element } from "svelte/internal";

// this class contains shared videos, that can be played by any game
export interface ISharedTranstionContext extends IContext {
    AddTransition(transitionResources: ITransitionParams) : Promise<ITransition>
    GetTransition(resid: ResourceIdentifier): ITransition;    
    //onTransitionEnd: () => void;

    // Show(resid: ResourceIdentifier): void;
    // Hide(resid: ResourceIdentifier): void;
    Update();
}


export interface VideoSettings {
    restartOnPlay?: boolean;
}

export class SharedTransitionContainer {

    protected view: HTMLElement;
    protected resid: ResourceIdentifier;
    protected logGroup: LogGroup;

    protected videos: Map<string, MyVideo> = new Map<string, MyVideo>();
    protected transitionMapContainerView: Map<string, ITransition> = new Map<string, ITransition>();

    protected transitionView: ITransition = null;
    protected transitionViewFactory: ITransitionFactory = new TransitionFactory();

    public constructor(resid: ResourceIdentifier, logGroup: LogGroup) {
        this.resid = resid.Add("SharedTransitionContainer");
        this.logGroup = logGroup.Add("SharedTransitionContainer");
        this.view = CreateElement("div", {
            classes: [this.resid.ID()], style: {
                width: Settings.ScreenWidth + "px",
                height: (Settings.Screens * Settings.ScreenHeight) + "px",
                top: Scale.Ypx(0),
                position: "absolute",
                pointerEvents: "none",
            }
        });
    }

    public onTransitionEnd:   () => void = null;

    public async AddTransition(transitionResources: ITransitionParams) : Promise<ITransition> {
        let container = CreateElement("div", {
            classes: [transitionResources.resid.ID()],
            style: {
                width: Settings.ScreenWidth + "px",
                height: (Settings.Screens * Settings.ScreenHeight) + "px",
                top: Scale.Ypx(0),
                position: "absolute",
                pointerEvents: "none",
                //background: "blue",
            }
        });

        
        //this.HideTransition(container);        
        this.view.append(container);

        // Create Transition Container
        let transitionViewFactory: ITransitionFactory = new TransitionFactory()
        let transitionView = transitionViewFactory.Create(transitionResources);
        await transitionView.ResourcesLoaded();
        // transitionView.onTransitionEnd = () => {
        //     //this.onTransitionEnd?.();
        //     console.log("TransitionShared-End")
        // }
        container.appendChild(transitionView.View());

        this.transitionMapContainerView.set(transitionResources.resid.ID(), transitionView);
        return transitionView
    }

    public GetTransition(resid: ResourceIdentifier) {
        let transitionView = this.transitionMapContainerView.get(resid.ID());
        if (!transitionView) {
            Log.Error(this.logGroup, "Trying to get video " + resid.ID() + ", but it does not exist!");
        }

        this.ShowTransition(transitionView.View().parentElement);

        return transitionView;
    }

    public View(): HTMLElement {
        return this.view;
    }

    protected ShowTransition(container: HTMLElement) {
        container.style.display = "";
    }

    protected HideTransition(container: HTMLElement) {
        container.style.display = "none";
    }

    public Update() {
        this.transitionMapContainerView.forEach(ele=>{
            ele.Update();
        })
    }
}

export class SharedTransitionContext implements ISharedTranstionContext {
    protected enabled: boolean = false

    protected resid: ResourceIdentifier;
    protected logGroup: LogGroup;

    protected sharedTransitionContainer: SharedTransitionContainer;

    //protected videoResources: Map<string, MyVideo> = new Map<string, MyVideo>();

    public constructor(resid: ResourceIdentifier, logGroup: LogGroup, sharedTransitionContainer: SharedTransitionContainer) {
        this.resid = resid;
        this.logGroup = logGroup;

        this.sharedTransitionContainer = sharedTransitionContainer;
    }    

    public GetTransition(resid: ResourceIdentifier) {

        return this.sharedTransitionContainer.GetTransition(resid);
    }
    public async AddTransition(transitionResources: ITransitionParams) {
        console.log(`ResourcesLoadedTransition-${transitionResources.gameName}`, transitionResources);        
        return await this.sharedTransitionContainer.AddTransition(transitionResources);
    }

    public Name(): string {
        return this.resid.ID();
    }

    public Enable(): void {
        if (!this.enabled) {
            this.enabled = true;
        }
    }

    public Disable(): void {
        if (this.enabled) {
            this.enabled = false;
        }
    }

    public Running(): boolean {
        return this.enabled;
    }

    public Update() {
       this.sharedTransitionContainer.Update();
    }
}